@if (telematicsStore.loading(); as loading) {
  <app-modal-loading-section [loading]="loading"></app-modal-loading-section>
} @else {
  <div class="toolbar" [class.double]="isDouble()">
    @if (isDouble()) {
      <onyx-chips
        [chips]="CHIPS"
        variant="secondary"
        [single]="true"
        [gap]="8"
        [(activeValues)]="mode"
      ></onyx-chips>
    }

    <onyx-button
      variant="outlined"
      [size]="32"
      (click)="toggleRoutesExpanded()"
    >
      {{
        `${I18N}.${areRoutesExpanded() ? 'collapseRoutes' : 'expandRoutes'}`
          | translate
      }}
    </onyx-button>
  </div>

  <div class="container">
    @if (isDouble()) {
      <app-swap-modal-route-item
        [route]="activeData().primary.route"
        [vehicleUuid]="vehicleData().vehicleUuid"
        [fuelType]="vehicleData().vehicleFuelType"
        heading="labels.route"
        identifierColor="blue"
        [areRoutesExpanded]="areRoutesExpanded()"
        [showRegistrationNumbers]="true"
        [vehicle]="swap().vehicle"
        [trailer]="activeData().primary.trailer"
      ></app-swap-modal-route-item>

      <app-swap-modal-route-item
        [route]="activeData().secondary.route"
        [vehicleUuid]="vehicleData().otherVehicleUuid"
        [fuelType]="vehicleData().otherVehicleFuelType"
        heading="labels.route"
        identifierColor="sea-green"
        [areRoutesExpanded]="areRoutesExpanded()"
        [showRegistrationNumbers]="true"
        [vehicle]="swap().otherVehicle"
        [trailer]="activeData().secondary.trailer"
      ></app-swap-modal-route-item>
    } @else {
      <app-swap-modal-route-item
        [route]="swap().vehicleRoute"
        [vehicleUuid]="swap().vehicle.uuid"
        [fuelType]="vehicleData().vehicleFuelType"
        [heading]="`${I18N}.afterSwap`"
        [areRoutesExpanded]="areRoutesExpanded()"
      ></app-swap-modal-route-item>

      <app-swap-modal-route-item
        [route]="swap().initialVehicleRoute"
        [vehicleUuid]="swap().vehicle.uuid"
        [fuelType]="vehicleData().vehicleFuelType"
        [heading]="`${I18N}.beforeSwap`"
        [areRoutesExpanded]="areRoutesExpanded()"
      ></app-swap-modal-route-item>
    }
  </div>
}
